import REDUX_ACTION from 'modules/redux/constants/action'

/**
 * Updates the instances at the given `paths` with the `updates`.
 * @param  {String[]}  paths
 * @param  {Object[]}  updates
 * @returns {Function}
 */
function bulkUpdateLegacyReduxAction ({ paths, updates }) {
  return {
    type: REDUX_ACTION.BULK_UPDATE,
    payload: {
      paths,
      updates
    }
  }
}

export {
  bulkUpdateLegacyReduxAction
}
